import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Paper, Typography, CircularProgress, Button, Box } from '@mui/material';
import { verifyEmail } from '../api/client';

const VerifyEmailPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');
    const [status, setStatus] = useState('verifying'); // verifying, success, error

    useEffect(() => {
        if (!token) {
            setStatus('error');
            return;
        }

        const verify = async () => {
            try {
                await verifyEmail(token);
                setStatus('success');
            } catch (err) {
                setStatus('error');
            }
        };
        verify();
    }, [token]);

    return (
        <Container maxWidth="sm" sx={{ py: 8 }}>
            <Paper sx={{ p: 4, textAlign: 'center', borderRadius: 4 }}>
                {status === 'verifying' && (
                    <>
                        <CircularProgress sx={{ mb: 2 }} />
                        <Typography variant="h5">Verifying your email...</Typography>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <Typography variant="h5" color="success.main" gutterBottom>
                            Email Verified Successfully!
                        </Typography>
                        <Box sx={{ mt: 2 }}>
                            <Button variant="contained" onClick={() => navigate('/login')}>
                                Go to Login
                            </Button>
                        </Box>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <Typography variant="h5" color="error.main" gutterBottom>
                            Verification Failed
                        </Typography>
                        <Typography color="text.secondary">
                            The link may be invalid or expired.
                        </Typography>
                    </>
                )}
            </Paper>
        </Container>
    );
};

export default VerifyEmailPage;
